import {noop} from '@benchling/js-utils';
import {Model} from 'backbone';
import React from 'react';

import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import SectionTabs from 'ui-library/SectionTabs';

export function renderPanelTabs(
  panelState: Model,
  tabs: Array<[key: string, tabId: string, panelId: string, title: string]>,
  node: Element
): void {
  renderToDOM(
    <SectionTabs
      tabs={tabs.map(([key, tabId, panelId, title]) => ({
        handleClick() {
          panelState.set('activeSubPanel', key);
        },
        ariaControls: panelId,
        id: tabId,
        isActive: panelState.get('activeSubPanel') === key,
        text: title,
      }))}
    />,
    node
  );
}

export function renderSinglePanelTab(id: string, panelId: string, title: string, node: Element): void {
  renderToDOM(
    <SectionTabs tabs={[{handleClick: noop, id, ariaControls: panelId, isActive: true, text: title}]} />,
    node
  );
}
